import { z } from '@uturn/portal/zod';

export const signInSchema = z.object({
	username: z.string().trim().toLowerCase().email(),
	password: z.string().min(1),
});

export type SignInFormValues = z.infer<typeof signInSchema>;
